<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">AR Group Posting 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(arAccCode)="data">
          {{ data.item.arAccCode}} | {{ data.item.arAccName}}
        </template>
        <template v-slot:cell(apUnearnedCode)="data">
          {{ data.item.apUnearnedCode}} | {{ data.item.apUnearnedName}}
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">AR Group - Add/Edit Form 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col class="pr-4" cols="6">
              <b-form-group  label-cols=3  label="Group Name" >
                  <b-form-input v-model="frmdata.NamaAR" :state="!$v.frmdata.NamaAR.$error"></b-form-input>
              </b-form-group>
              <b-form-group label-cols=4  label="Receivable Account">
                  <b-input-group >
                      <b-form-input readonly v-model="frmdata.arAccInfo" :state="!$v.frmdata.arAccCode.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('arAcc')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
              <b-form-group label-cols=4  label="Unearned/PBB Income Acc.">
                  <b-input-group >
                      <b-form-input readonly v-model="frmdata.apUnearnedInfo" :state="!$v.frmdata.apUnearnedCode.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('apUnearned')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
              <b-form-group label-cols=4  label="Default Sales/Revenue">
                  <b-form-select v-model="frmdata.saleCode" :plain="true" :options="salesAccounts" :state="!$v.frmdata.saleCode.$error"></b-form-select>
              </b-form-group>
          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import arinv from "../../apis/arinv";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuCoa},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        NamaAR: { required },
        arAccCode: { required },
        saleCode: { required },
        apUnearnedCode: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      lkuCoaShow:false,
      lkuCoaCaller:'arAcc',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{NamaAR: '',budgeted: '', arAccCode: '', saleCode: '', apUnearnedCode:'' },
        salesAccounts:[],
      tblData: {
        tablename:'artype',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "NamaAR",
            label: "AR Type/Group Name",
            sortable: true
          },
          {
            key: "arAccCode",
            label: "Receivable Account",
            sortable: true
          },
          {
            key: "apUnearnedCode",
            label: "Unearned/PBB Income Account",
            sortable: true
          },
          {
            key: "NamaSale",
            label: "Default Sales Account",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function(){
    this.salesAccounts = await arinv.salesAccount();
  },
  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      // this.frmdata.grouplama = data.groupname;
      this.frmdata.kodelama = data.artypeId;
      this.frmdata.arAccInfo = (data.arAccCode || '').trim() + ' | ' + (data.arAccName || '').trim();
      this.frmdata.apUnearnedInfo = (data.apUnearnedCode || '').trim() + ' | ' + (data.apUnearnedName || '').trim();
      // this.frmdata.saleFeeInfo = (data.saleFeeCode || '').trim() + ' | ' + (data.saleFeeName || '').trim();
      // this.frmdata.saleDiscInfo = (data.saleDiscCode || '').trim() + ' | ' + (data.saleDiscName || '').trim();
      // this.frmdata.PrePaymDbAccInfo = data.PrePaymDbAcc;
      // let _selected;
      // try {
      //   if (data.apUnearnedInfo) {
      //     _selected = await crud.findcoa({kodeacc: data.apUnearnedCode, tahun: this.tahun});
      //     this.frmdata.apUnearnedInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.ApUnBillCrAcc) {
      //     _selected = await crud.findcoa({kodeacc: data.ApUnBillCrAcc, tahun: this.tahun});
      //     this.frmdata.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.PrePaymDbAcc) {
      //     _selected = await crud.findcoa({kodeacc: data.PrePaymDbAcc, tahun: this.tahun});
      //     this.frmdata.PrePaymDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      // } catch (error) {
      //   if (error.message) {
      //       toastr.error(error.message);
      //   } else {
      //       toastr.error(JSON.stringify(error));
      //   }                      
      // }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.kodelama) {
                await crud.update(
                     {tablename:'argroup', 
                     key:this.frmdata.kodelama, 
                     data:{NamaAR:this.frmdata.NamaAR,
                          arAccCode:this.frmdata.arAccCode,
                          arAccName:this.frmdata.arAccName,
                          apUnearnedCode:this.frmdata.apUnearnedCode,
                          apUnearnedName:this.frmdata.apUnearnedName,
                          saleCode:this.frmdata.saleCode
                          }
                      });
              } else {
                await crud.insert(
                  { tablename:'argroup',                      
                    data:{NamaAR:this.frmdata.NamaAR,
                          arAccCode:this.frmdata.arAccCode,
                          arAccName:this.frmdata.arAccName,
                          apUnearnedCode:this.frmdata.apUnearnedCode,
                          apUnearnedName:this.frmdata.apUnearnedName,
                          saleCode:this.frmdata.saleCode,
                          }
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'argroup', key:this.model.artypeId});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}Code`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}Name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
